module.exports = __webpack_public_path__ + "img/prioritas_vippack_cod.e39f794b.png";